import ModalDrawerChangeView from './ModalDrawerChangeView';

export default ModalDrawerChangeView;